/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const OperatorActivityType = {
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE'
} as const;
export type OperatorActivityType = typeof OperatorActivityType[keyof typeof OperatorActivityType];

